/**
 * R4's sheet: tapping an award chip opens an overlay naming the pool and
 * the contest it came from. Uses `@sportsmet/ui`'s `Dialog`, the kit's
 * responsive overlay (a bottom sheet under 768px, a centered dialog at
 * 768px and up), so this screen never branches on viewport width.
 */
import { Button, Dialog } from "@sportsmet/ui";
import type { ReactNode } from "react";

import type { typeAwardChip } from "../awards/awardChips";
import {
  AWARD_SHEET_CLOSE_LABEL,
  AWARD_SHEET_CONTEST_LABEL,
  AWARD_SHEET_POOL_LABEL,
  AWARD_SHEET_TITLE,
  AWARD_SHEET_UNKNOWN_VALUE,
} from "./accountHomeCopy";

export type typeAwardChipDialogProps = {
  open: boolean;
  onClose: () => void;
  chip: typeAwardChip | null;
  poolName: string | null;
  testId?: string | undefined;
};

export const AwardChipDialog = (props: typeAwardChipDialogProps): ReactNode => (
  <Dialog
    open={props.open}
    onOpenChange={(next) => {
      if (!next) {
        props.onClose();
      }
    }}
    title={AWARD_SHEET_TITLE}
    autoFocus={false}
    footer={
      <Button variant="secondary" onClick={props.onClose}>
        {AWARD_SHEET_CLOSE_LABEL}
      </Button>
    }
  >
    <dl className="flex flex-col gap-3" data-testid={props.testId}>
      <p className="text-body-strong text-ink" data-testid="award-sheet-name">
        {props.chip?.name ?? ""}
      </p>
      <div className="flex flex-col gap-1">
        <dt className="text-caption text-ink-secondary">
          {AWARD_SHEET_POOL_LABEL}
        </dt>
        <dd className="text-body text-ink" data-testid="award-sheet-pool">
          {props.poolName ?? AWARD_SHEET_UNKNOWN_VALUE}
        </dd>
      </div>
      <div className="flex flex-col gap-1">
        <dt className="text-caption text-ink-secondary">
          {AWARD_SHEET_CONTEST_LABEL}
        </dt>
        <dd className="text-body text-ink" data-testid="award-sheet-contest">
          {props.chip?.contestName ?? AWARD_SHEET_UNKNOWN_VALUE}
        </dd>
      </div>
    </dl>
  </Dialog>
);
